import React from 'react'
import Header from '../common/Header.js'
import InnerBanner from '../common/InnerBanner.js'
import Footer from '../common/Footer.js'

export const Privacy = () => {
  return (
    <>
      <Header />

      <InnerBanner title="Security & Privacy Policy" />

      <div className="w3l-faq-main">
        <div className="faq-sec sec-padding">
          <div className="wrapper">
            <div className="faq-cont">
              <div className="about-right-faq">

                <div className="bg-warning text-dark p-3">
                  <b>Important:</b> Please read this Security & Privacy
                  Policy carefully to understand how DLMP21 collects, uses,
                  protects and manages personal information.
                </div>

                <br />

                <h4 className="head-terms">
                  <b>1. PRIVACY AND INFORMATION SECURITY POLICY</b>
                </h4>

                <p className="all-terms">
                  Dreams Linkage Marketing Pro 21 (I)(OPC) PVT. LTD.
                  ("DLMP21", "we", "us" or "our") operates the DLMP21
                  website, application and related services.
                </p>

                <p className="all-terms">
                  DLMP21 is committed to protecting the privacy and security
                  of personal information that we collect or receive in
                  connection with your use of the DLMP21 website, application
                  and services.
                </p>

                <p className="all-terms">
                  This Privacy Policy explains the types of information that
                  may be collected, the purposes for which the information may
                  be used, how information may be protected, and the ways in
                  which you may contact us regarding your personal information.
                </p>


                {/* INFORMATION COLLECTION */}
                <br />

                <h4 className="head-terms">
                  <b>2. INFORMATION WE COLLECT</b>
                </h4>

                <p className="all-terms">
                  DLMP21 may collect personal information that you provide
                  while registering for an account, using our services,
                  communicating with us or participating in activities
                  available through the platform.
                </p>

                <p className="all-terms">
                  Depending on the service being used, this may include
                  information such as your name, email address, location or
                  postal/ZIP code, account information and other information
                  that you voluntarily provide through the website or
                  application.
                </p>

                <p className="all-terms">
                  DLMP21 may also receive information automatically from your
                  browser or device, including technical information and
                  server-log information such as IP address, browser
                  information, pages requested and related usage information.
                </p>


                {/* HOW WE USE INFORMATION */}
                <br />

                <h4 className="head-terms">
                  <b>3. HOW WE USE YOUR INFORMATION</b>
                </h4>

                <p className="all-terms">
                  DLMP21 may use information collected from or provided by
                  users for purposes including:
                </p>

                <p className="all-terms">
                  • Creating and managing user accounts.
                  <br />
                  • Providing and operating DLMP21 services.
                  <br />
                  • Maintaining customer and business-partner records.
                  <br />
                  • Recording and managing eligible activity on the platform.
                  <br />
                  • Communicating with users about services, updates, offers
                  and other relevant information.
                  <br />
                  • Improving website, application and service functionality.
                  <br />
                  • Maintaining security, preventing misuse and investigating
                  suspicious activity.
                  <br />
                  • Complying with applicable legal and regulatory
                  requirements.
                </p>


                {/* AGE */}
                <br />

                <h4 className="head-terms">
                  <b>4. AGE REQUIREMENT</b>
                </h4>

                <p className="all-terms">
                  DLMP21 does not knowingly seek to collect personal
                  information from persons under 18 years of age where the
                  applicable service requires the user to be 18 or older.
                </p>

                <p className="all-terms">
                  If you believe that a person under the applicable age has
                  provided personal information to DLMP21, please contact us
                  so that we can review the situation and take appropriate
                  action where required.
                </p>


                {/* COOKIES */}
                <br />

                <h4 className="head-terms">
                  <b>5. USE OF COOKIES AND SIMILAR TECHNOLOGIES</b>
                </h4>

                <p className="all-terms">
                  DLMP21 may use cookies and similar technologies to support
                  website functionality, remember preferences, understand
                  website usage and improve the user experience.
                </p>

                <p className="all-terms">
                  Depending on your browser settings and the services being
                  used, you may be able to block, delete or receive warnings
                  about cookies. Disabling certain cookies may affect the
                  availability or functionality of some parts of the website
                  or application.
                </p>

                <p className="all-terms">
                  Where third-party services or websites use their own
                  cookies or similar technologies, those technologies may be
                  governed by the privacy policies of the respective
                  third parties.
                </p>


                {/* INFORMATION SHARING */}
                <br />

                <h4 className="head-terms">
                  <b>6. SHARING OF PERSONAL INFORMATION</b>
                </h4>

                <p className="all-terms">
                  DLMP21 does not intend to sell or rent your personal
                  information as a commercial data product.
                </p>

                <p className="all-terms">
                  Information may be shared where necessary to provide a
                  service requested by you, operate the DLMP21 platform,
                  protect the security of the service, or comply with
                  applicable legal obligations.
                </p>

                <p className="all-terms">
                  Where third-party service providers are used to support
                  DLMP21 services, DLMP21 may require appropriate contractual
                  or operational safeguards consistent with the purpose for
                  which information is shared.
                </p>

                <p className="all-terms">
                  Information may also be disclosed where required by law,
                  court order, subpoena or other lawful legal process.
                </p>


                {/* DATA SECURITY */}
                <br />

                <h4 className="head-terms">
                  <b>7. INFORMATION SECURITY</b>
                </h4>

                <p className="all-terms">
                  DLMP21 maintains technical and managerial measures designed
                  to protect personal information against unauthorized access,
                  misuse, loss, alteration or disclosure while the information
                  is under our control.
                </p>

                <p className="all-terms">
                  Personal information may be stored on secured systems and
                  access may be restricted to authorized personnel and
                  service providers who need access for legitimate business
                  purposes.
                </p>

                <p className="all-terms">
                  Users are responsible for maintaining the confidentiality
                  of their account credentials and should notify DLMP21
                  promptly if they believe that their account has been
                  accessed or used without authorization.
                </p>


                {/* IP ADDRESS */}
                <br />

                <h4 className="head-terms">
                  <b>8. IP ADDRESS AND TECHNICAL INFORMATION</b>
                </h4>

                <p className="all-terms">
                  DLMP21 may collect and retain IP addresses and related
                  technical information for purposes such as system
                  administration, security, troubleshooting, fraud prevention
                  and service operation.
                </p>

                <p className="all-terms">
                  Server logs may record information about requests made to
                  the DLMP21 website or application.
                </p>


                {/* DATA RETENTION */}
                <br />

                <h4 className="head-terms">
                  <b>9. DATA RETENTION</b>
                </h4>

                <p className="all-terms">
                  DLMP21 may retain personal information for as long as
                  reasonably necessary for the purposes for which it was
                  collected, to provide services, maintain business and
                  transaction records, resolve disputes, protect security,
                  comply with legal obligations, or for other lawful
                  purposes.
                </p>

                <p className="all-terms">
                  Retention periods may therefore vary depending on the type
                  of information and the purpose for which it is maintained.
                </p>


                {/* USER RIGHTS */}
                <br />

                <h4 className="head-terms">
                  <b>10. MANAGING YOUR INFORMATION</b>
                </h4>

                <p className="all-terms">
                  You may contact DLMP21 to request information regarding
                  personal data associated with your account, including
                  requests for correction or deletion where applicable.
                </p>

                <p className="all-terms">
                  Requests can be sent to:
                </p>

                <p className="all-terms">
                  <b>Email:</b> support@dlmp21.in
                </p>

                <p className="all-terms">
                  DLMP21 may need to verify the identity of the requester
                  before processing a request. Certain information may also
                  need to be retained where required for legal, regulatory,
                  security or legitimate business purposes.
                </p>


                {/* THIRD PARTY LINKS */}
                <br />

                <h4 className="head-terms">
                  <b>11. THIRD-PARTY WEBSITES AND SERVICES</b>
                </h4>

                <p className="all-terms">
                  The DLMP21 website or application may contain links to
                  third-party websites or services.
                </p>

                <p className="all-terms">
                  Third-party websites and services are not controlled by
                  DLMP21, and their privacy practices may differ from this
                  Privacy Policy. Users should review the privacy policy of
                  each third-party service before providing personal
                  information to it.
                </p>


                {/* BUSINESS PARTNERS */}
                <br />

                <h4 className="head-terms">
                  <b>12. BUSINESS PARTNERS</b>
                </h4>

                <p className="all-terms">
                  DLMP21 may work with participating businesses, franchisees,
                  service providers and other business partners in operating
                  the platform and providing related services.
                </p>

                <p className="all-terms">
                  Where personal information is processed or shared as part of
                  a service involving a third party, the applicable processing
                  and privacy responsibilities may depend on the nature of
                  that service and the relationship between the parties.
                </p>


                {/* DATA ACCURACY */}
                <br />

                <h4 className="head-terms">
                  <b>13. ACCURACY OF INFORMATION</b>
                </h4>

                <p className="all-terms">
                  Users are responsible for providing accurate and current
                  information and for informing DLMP21 when account
                  information needs to be corrected or updated.
                </p>


                {/* POLICY UPDATES */}
                <br />

                <h4 className="head-terms">
                  <b>14. POLICY UPDATES</b>
                </h4>

                <p className="all-terms">
                  DLMP21 may update or revise this Privacy Policy from time
                  to time to reflect changes in the services, technology,
                  business practices, legal requirements or applicable
                  privacy standards.
                </p>

                <p className="all-terms">
                  Updated versions will be published on the website or
                  application. Users are encouraged to review this page
                  periodically.
                </p>


                {/* CONTACT */}
                <br />

                <h4 className="head-terms">
                  <b>15. CONTACT US</b>
                </h4>

                <p className="all-terms">
                  For privacy-related questions, requests or comments, please
                  contact:
                </p>

                <p className="all-terms">
                  <b>Customer Care:</b>+91 8856819762
                  <br />
                  <b>Email:</b> support@dlmp21.in
                </p>

                <p className="all-terms">
                  <b>Last Updated:</b> September 2026
                </p>

              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  )
}

export default Privacy